import { Link } from "react-router-dom";
import { ArrowRight, Plus } from "lucide-react";
import Reveal from "../components/Reveal";

const INGREDIENTS = [
  { label: "YOUR EXPERTISE", testid: "signature-equation-expertise" },
  { label: "OUR STRATEGY", testid: "signature-equation-strategy" },
  { label: "YOUR STORY", testid: "signature-equation-story" },
  { label: "OUR DESIGN & TECHNOLOGY", testid: "signature-equation-technology" },
];

export default function SignatureSales() {
  return (
    <section data-testid="signature-sales-section" className="relative overflow-hidden py-24 sm:py-32">
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(55% 60% at 50% 40%, rgba(212,175,55,0.07), transparent)" }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <p className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">AT DIGITAL SIGNATURE</p>
          <h2 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
            You know your business.
            <br />
            <span className="text-gold-gradient">We find the story.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mx-auto mt-8 max-w-2xl text-base leading-relaxed text-slate-400">
            You shouldn't have to become a copywriter, designer, developer and digital strategist just to explain what
            makes your company valuable.
          </p>
          <p className="mt-4 font-display text-xl font-semibold text-white">That's our job.</p>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-slate-400">
            We learn how your business works, understand who you're trying to reach, identify what makes customers
            choose you, develop the story, design the experience and build the technology around it.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mx-auto mt-14 max-w-md">
            {INGREDIENTS.map((item, i) => (
              <div key={item.label}>
                <div
                  data-testid={item.testid}
                  className="rounded-xl border border-navyline bg-navycard/70 px-6 py-4 font-mono text-xs font-bold tracking-[0.24em] text-slate-200"
                >
                  {item.label}
                </div>
                {i < INGREDIENTS.length - 1 && (
                  <Plus className="mx-auto my-2 h-4 w-4 text-gold/60" aria-hidden="true" />
                )}
              </div>
            ))}
            <div className="gold-hairline my-6 h-px" aria-hidden="true" />
            <div className="rounded-xl border-2 border-gold/70 bg-navy px-6 py-6 shadow-lg shadow-gold/10">
              <p className="font-mono text-xs font-bold tracking-[0.24em] text-gold">A DIGITAL EXPERIENCE</p>
              <p className="mt-2 font-display text-lg font-bold text-white">BUILT AROUND YOUR BUSINESS</p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.35}>
          <Link
            to="/start?package=signature"
            data-testid="signature-explore-cta"
            className="group mt-12 inline-flex items-center gap-2.5 rounded-full bg-gold px-8 py-4 text-sm font-bold text-ink shadow-lg shadow-gold/20 transition-colors duration-300 hover:bg-goldlight"
          >
            Explore Signature
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
